<template>
	<FormulateForm v-if="!loading" ref="form" v-model="form" @submit="save">
		<FormulateInput label="Nombre" name="name" validation-name="Nombre" validation="required" />

		<FormulateInput label="Apellido" name="lastname" validation-name="Apellido" validation="required" />

		<FormulateInput type="identification" label="Documento de identidad" name="document" validation-name="Documento de identidad" validation="optional|^documentID" />

		<FormulateInput label="Teléfono" type="phone" name="phone" validation-name="Teléfono" validation="optional|^phone" />


		<button class="mt-4 mb-2 cursor-pointer" type="button" @click="()=>{collapsed = !collapsed}">
			<span v-if="collapsed">Mostrar datos opcionales<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-down" viewBox="0 0 16 16">
  				<path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/></svg>
			</span>
			<span v-else>Ocultar datos adicionales <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-up" viewBox="0 0 16 16">
  				<path fill-rule="evenodd" d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708l6-6z"/></svg>
			</span>
		</button>
		<div v-show="!collapsed" >
			<FormulateInput label="Email (opcional)" type="email" name="email" />
			
			<FormulateInput label="Sexo (opcional)" name="sex" :options="{ MALE: 'Masculino', FEMALE: 'Femenino', UNKNOWN: 'Desconocido', NO_APPLY: 'No aplica' }" type="select" placeholder="Seleccione un sexo"  />
			<FormulateInput class="mt-2" type="date" name="birthdate" label="Fecha de nacimiento (opcional)" :splitted="true"  />

			<div class="section-title mt-4 mb-2">Dirección de residencia</div>
			<div class="row row-xs">
				<!-- <div class="col-12 col-md-6 mb-2">
					<FormulateInput
						label="País"
						validation-name="País"
						name="addressCountry"
						:options="countries"
						type="selectSearch"
						option-value="id"
						option-text="name"
						placeholder="Seleccione un país"
						validation="required"
						:disabled="loadingCountries"
					/>
					<div class="formulate-input-help " v-if="loadingCountries">Cargando paises...</div>
				</div> -->
				
				<div class="col-12 col-md-6 mb-2">
					<FormulateInput
						label="Departamento"
						validation-name="Departamento"
						v-model="selectedRegion"
						:options="regions"
						type="selectSearch"
						option-value="id"
						option-text="name"
						placeholder="Seleccione una region"
						:disabled="loadingCountries"
					/>
					<div class="formulate-input-help " v-if="loadingCountries">Cargando regiones...</div>
				</div>
				
				<div class="col-12 col-md-6 mb-2">
					<FormulateInput
						label="Localidad"
						validation-name="Localidad"
						name="addressLocality"
						:options="localities"
						type="selectSearch"
						option-value="id"
						option-text="name"
						placeholder="Seleccione una localidad"
						:disabled="loadingCountries"
					/>
					<div class="formulate-input-help " v-if="loadingCountries">Cargando localidades...</div>
				</div>
				
				<!-- <div class="col-12 col-md-6 mb-2">
					<FormulateInput label="Ciudad" name="addressCity" validation-name="Ciudad" validation="required" />
				</div> -->
			</div>

			<div class="row row-xs">
				<div class="col-12 col-md-8 mb-2">
					<FormulateInput label="Calle" name="addressStreet" validation-name="Calle" />
				</div>
				<div class="col-12 col-md-4 mb-2">
					<FormulateInput label="Número" name="addressNumber" validation-name="Número" />
				</div>
			</div>
			<FormulateInput label="Datos adicionales" name="addressComments"  placeholder="Ej: manzana, solar, número de local, etc..." />
		</div>

	
		<div class="alert alert-danger" v-if="CIalreadyExists">
			Ya existe un paciente con el mismo número de documento de identidad.
		</div>
		<hr />
		<div class="d-flex justify-content-between mt-4">
			<FormulateInput type="button" data-ghost @click="$router.go(-1)">Cancelar</FormulateInput>
			<FormulateInput type="button" disabled v-if="saving">Guardando <span class="loader"/></FormulateInput>
			<FormulateInput type="submit" :label="title" v-else />
		</div>
	</FormulateForm>
</template>

<script>
import gql from "graphql-tag"
import mixins from "@/mixins/mixins"
import formMixins from "@/mixins/formMixins"

export default {
	name: "PatientForm",
	mixins: [mixins, formMixins],
	props: ["id"],
	data() {
		return {
			title: "Crear paciente",
			action: "create",
			loading: true,
			saving: false,
			loadingCountries: true,
			countries: [],
			regions: [],
			selectedRegion: null,
			CIalreadyExists: false,
			collapsed: true,
			form: {
				name: null,
				lastname: null,
				document: {
					type: "UY",
					number: null
				},
				birthdate: null,
				email: null,
				phone: null,
				sex: null,
				addressCountry: 226,
				addressLocality: null,
				addressStreet: null,
				addressNumber: null,
				addressComments: null
				
			}
		}
	},
	computed:{
		localities(){
			if(this.selectedRegion){
				let regions =  this.regions.find(r=>r.id==this.selectedRegion).localities
				// sort by name
				regions.sort((a,b)=>a.name.localeCompare(b.name))
				return regions
			}
			return []
		}
	},
	async beforeMount() {
		await this.fetchData()
		if (this.id) {
			this.title = `Editar paciente`
			this.action = "update"
			await this.load()
		}
		this.loading = false
	},
	methods: {
		save() {
			if (!this.saving) {
				this.saving = true
				this.CIalreadyExists = false
				let dataInput = {
					name: this.form.name,
					lastname: this.form.lastname,
					email: this.form.email,
					document: this.form.document,
					birthdate: this.$moment(this.form.birthdate).format("YYYY-MM-DD"),
					phone: this.form.phone,
					sex: this.form.sex || 'UNKNOWN',
					addressCountry: this.form.addressCountry,
					addressLocality: this.form.addressLocality,
					addressStreet: this.form.addressStreet,
					addressNumber: this.form.addressNumber,
					addressComments: this.form.addressComments,
				}

				if (this.action == "create") {
					this.create(dataInput)
				}
				if (this.action == "update") {
					this.update(dataInput)
				}
			}
		},

		create(data) {
			this.$apollo
				.mutate({
					mutation: gql`
						mutation($data: PatientInput!) {
							patientCreate(data: $data) {
								id
								name
								email
							}
						}
					`,
					variables: {
						data
					}
				})
				.then(({ data }) => {
					this.$toast.success("Paciente creado correctamente")
					this.$emit("created", data.patientCreate)
					this.saving = false
					this.CIalreadyExists = false
				})
				.catch(error => {

					// if error has ER_DUP_ENTRY in message show error
					console.log(error)
					if (error.graphQLErrors[0].message.indexOf("ER_DUP_ENTRY") !== -1) {
  						// El mensaje de error contiene el string "ER_DUP_ENTRY".
						  this.CIalreadyExists = true
					}else{
						this.parseGQLErrors(error)
						
					}
					this.saving = false
				})
		},

		update(dataInput) {
			this.$apollo
				.mutate({
					mutation: gql`
						mutation($id: ID!, $data: PatientInput!) {
							patientUpdate(id: $id, data: $data) {
								id
								name
								email
							}
						}
					`,
					variables: {
						id: this.id,
						data: dataInput
					}
				})
				.then(({ data }) => {
					this.$toast.success("Paciente editado correctamente")
					this.$emit("updated", data.patientUpdate)
					this.saving = false
				})
				.catch(error => {
					this.errors = this.parseGQLErrors(error)
					this.saving = false
				})
		},

		load() {
			return this.$apollo
				.query({
					query: gql`
						query($id: ID!) {
							patient(id: $id) {
								id
								name
								lastname
								email
								birthdate
								document {
									type
									number
								}
								sex
								phone {
									countryCode
									national
									international
									type
									validated
								}
								address {
									country {
										id
										name
									}
									locality{
										id name
									}
									street
									number
									comments
								}
							}
						}
					`,
					variables: { id: this.id },
					fetchPolicy: "network-only"
				})
				.then(({ data }) => {
					console.log(data)
					this.form = {
						...this.$omitDeep(data.patient, "__typename"),
						addressCountry: data.patient.address && data.patient.address.country ? data.patient.address.country.id : null,
						addressLocality: data.patient.address && data.patient.address.locality ? data.patient.address.locality.id : null,
						addressStreet: data.patient.address && data.patient.address.street ? data.patient.address.street : null,
						addressNumber: data.patient.address && data.patient.address.number ? data.patient.address.number : null,
						addressComments: data.patient.address && data.patient.address.comments ? data.patient.address.comments : null,
					}
					if(data.patient.address){
						this.selectedRegion = this.regions.find(r=>r.localities.find(l=>l.id==data.patient.address.locality.id)).id
					}
				})
				.catch(() => {
					this.$toast.success("El item que desea editar no existe")
					// this.$router.go(-1)
				})
		},

		fetchData() {
			this.loadingCountries = true
			return this.$apollo
				.query({
					query: gql`
						query {
							countries {
								id
								iso
								name
								nativeName
								flag
							}
							regions{
								id
								name
								localities{
									id name
								}
							}
						}
					`,
					fetchPolicy: "network-only"
				})
				.then(({ data }) => {
					// this.countries = this.covertArrayToSelectableObject(data.countries)
					this.countries = data.countries
					this.regions = data.regions
					this.loadingCountries = false
					this.$nextTick(() => {
						this.form.addressCountry = 226
					})
				})
				.catch(err => {
					console.log(err)
				})
		}
	}
}
</script>

<style></style>
